// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum Direction {
  Unknown = 0,
  Up = 1,
  Down = 2,
  Left = 3,
  Right = 4,
  Idle = 5
}
